import axiosInstance from "./axiosInstance";

export const listSavedFilters = async (projectId) => {
  const response = await axiosInstance.get(`/projects/${projectId}/saved-filters`);
  return Array.isArray(response.data?.items) ? response.data.items : [];
};

export const createSavedFilter = async (projectId, { name, filters, is_default = false }) => {
  const response = await axiosInstance.post(
    `/projects/${projectId}/saved-filters`,
    { name, filters, is_default },
  );
  return response.data;
};


export const updateSavedFilter = async (projectId, viewId, partial) => {
  const response = await axiosInstance.patch(
    `/projects/${projectId}/saved-filters/${viewId}`,
    partial,
  );
  return response.data;
};


export const deleteSavedFilter = async (projectId, viewId) => {
  await axiosInstance.delete(`/projects/${projectId}/saved-filters/${viewId}`);
};

export const buildFiltersFromUiState = ({
  householdSearchTerm,
  selectedStatus,
  selectedAdvisorId,
  sortBy,
  sortOrder,
}) => {
  // Mirrors the backend HouseholdFilters schema 1:1. Pagination is intentionally
  // not part of a saved filter (transient). Advisor is stored by stable ID — the
  // FE looks up the display name from project.advisors at render time.
  return {
    q: householdSearchTerm || null,
    status: selectedStatus || null,
    advisor_id: selectedAdvisorId || null,
    sort_by: sortBy || "updated_at",
    sort_order: sortOrder || "desc",
  };
};


export const applyFiltersToUiState = (filters, project) => {
  let advisorId = "";
  const advisors = project?.advisors || [];

  if (filters?.advisor_id && advisors.length) {
    const matchById = advisors.find(
      (a) =>
        a.user_id === filters.advisor_id || a.id === filters.advisor_id,
    );
    if (matchById) {
      advisorId = matchById.user_id || String(advisors.indexOf(matchById));
    } else if (/^\d+$/.test(String(filters.advisor_id))) {
      // Legacy: advisor_id stored on a household was a numeric index into
      // project.advisors. Treat it the same so older data still resolves.
      const i = parseInt(filters.advisor_id, 10);
      if (advisors[i]) advisorId = String(i);
    }
  }

  return {
    householdSearchTerm: filters?.q || "",
    selectedStatus: filters?.status || "",
    selectedAdvisorId: advisorId,
    sortBy: filters?.sort_by || "updated_at",
    sortOrder: filters?.sort_order || "desc",
  };
};
